export default "__VITE_ASSET__Gqn6qnid__"